/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import T from 'prop-types';
export var Icon = function Icon(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      stroke: 'none',
      strokeWidth: 1,
      fill: 'none',
      fillRule: 'evenodd',
      overflow: 'visible'
    }
  }, props));
};
export var ArrowDownIcon = function ArrowDownIcon(_ref2) {
  var style = _ref2.style;
  return /*#__PURE__*/React.createElement(Icon, {
    style: style,
    viewBox: "0 -4 22 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1679 2.07693L19.1844 0.127487L10.9013 8.58463L2.44418 0.301495L0.496094 2.32027L10.9707 12.5175L21.1679 2.07693Z",
    fill: "white"
  }));
};
export var ArrowRightIcon = function ArrowRightIcon(_ref3) {
  var style = _ref3.style;
  return /*#__PURE__*/React.createElement(Icon, {
    style: style,
    viewBox: "-4 0 22 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.58665 0.986454L0.637206 2.96987L9.09435 11.253L0.811215 19.7101L2.82999 21.6582L13.0272 11.1836L2.58665 0.986454Z",
    fill: "white"
  }));
};
export var ArrowLeftIcon = function ArrowLeftIcon(_ref4) {
  var style = _ref4.style;
  return /*#__PURE__*/React.createElement(Icon, {
    style: style,
    viewBox: "-4 0 22 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0777 21.6582L13.0271 19.6748L4.56996 11.3917L12.8531 2.93454L10.8343 0.98645L0.637099 11.461L11.0777 21.6582Z",
    fill: "white"
  }));
};
export var ArrowUpIcon = function ArrowUpIcon(_ref5) {
  var style = _ref5.style;
  return /*#__PURE__*/React.createElement(Icon, {
    style: style,
    viewBox: "0 -4 22 23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.496205 10.568L2.47962 12.5174L10.7627 4.0603L19.2199 12.3434L21.168 10.3247L10.6934 0.12744L0.496205 10.568Z",
    fill: "white"
  }));
};
var iconPropTypes = {
  style: T.object
};
ArrowUpIcon.propTypes = iconPropTypes;
ArrowDownIcon.propTypes = iconPropTypes;
ArrowRightIcon.propTypes = iconPropTypes;
ArrowLeftIcon.propTypes = iconPropTypes;